module.exports = __webpack_public_path__ + "static/img/3.b43143b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/17/sp/3.png
// module id = xsed
// module chunks = 0